<template>
  <q-tab-pane name="danger-zone">
    <div class="danger-box round-borders q-pa-md">
      <div class="row items-center gutter-x-md">
        <div class="col-12 col-md">
          <h6 class="q-my-sm q-title">{{ $t('delete_team') }}</h6>
          <p v-html="$t('delete_team_hint')" class="q-ma-none text-faded"></p>
        </div>

        <div class="col-12 col-md-auto">
          <q-btn color="red-6" icon="warning" class="q-mt-md" @click="handleDeleteTeam">
            &nbsp;{{ $t('delete_team') }}
          </q-btn>
        </div>
      </div>
    </div>

    <authorization-dialog ref="authorizationDialog"></authorization-dialog>
  </q-tab-pane>
</template>

<script>
  import AuthorizationDialog from 'components/Common/AuthorizationDialog.vue'
  import { TeamClient } from 'src/api/Teams'
  import { createErrorFromResponse } from 'src/utils/error'
  import { mapGetters } from 'vuex'

  export default {
    computed: mapGetters(['team']),

    methods: {
      handleDeleteTeam () {
        this.$refs.authorizationDialog.open()
          .then(authorizationPassword => {
            this.deleteTeam(authorizationPassword)
          })
      },

      deleteTeam (authorizationPassword) {
        new TeamClient()
          .delete(this.team.id, authorizationPassword)
          .then(() => {
            this.$q.notify({ message: this.$t('team_deleted'), type: 'positive' })
          })
          .catch(createErrorFromResponse)
      }
    },

    components: {
      AuthorizationDialog
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .danger-box
    border: 2px solid $red-3
</style>
